import React from 'react';
import ChartDatasetSettings from '../../settings_sidebar/ChartDatasetSettings.jsx';
import { DEFAULT_ADDITIONAL_SETTINGS } from '../../settings_sidebar/chart/ChartSettings.jsx';
import TimelineWidgetSettingsRow from './TimelineWidgetSettingsRow.jsx';

function TimelineWidgetSettings({ widgetId }) {

    return (<>
        <hr />
        <ChartDatasetSettings
            widgetId={widgetId}
            chart_settings_props={{
                additional_settings: [...DEFAULT_ADDITIONAL_SETTINGS, "timeline"],
            }}
            dataset_settings_props={{
                DatasetSettingsRowComponent: TimelineWidgetSettingsRow,
                elementTitle: I18n.t('node'),
                sectionTitle: I18n.t('nodes')
            }}
        />
    </>)
} 

export default TimelineWidgetSettings;
